<template>
  <bb-modal v-bind="modalProps" data-testid="current-account-modal" @close="() => console.log('close')">
    <template #heading>
      <div class="header m-y-5">{{ translations.modalTitle }}</div>
    </template>
    <div>
      <div class="icon-wrapper">
        <bb-icon class="icon" name="illustration-exclamation-mark" size="fluid" fill="mint"/>
      </div>
      <div class="m-t-15 text">
        <div>
          <span v-sanitize.basic="translations.toUseInternetBank"/>
        </div>
        <div>
          <span v-sanitize.basic="translations.withoutCompleting"/>
        </div>
      </div>
      <div class="m-t-15 p-b-10 text">
        <span class="f-strong f-color-mint">{{ translations.whatToDo }}</span>
        <ul class="m-t-20">
          <li
            v-for="(point, index) in translations.list"
            :key="index"
            class="current-account-modal__list-item m-b-10"
          >
            <bb-icon name="ui-check" size="24" fill="mint"/>
            <span class="m-l-10 m-t-3">{{ point }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="m-t-15 text">
      <div>
        <span v-sanitize.basic="translations.mandatoryStep"/>
      </div>
      <div>
        <span>{{ translations.contactCustomerSupport }}</span>
      </div>
      <div>
        <span>{{ translations.thankYou }}</span>
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <div>
        <bb-button @click="onLogout" data-testid="log-out-permission-confirmation-modal"
                   class="p-x-5 w-100" :label="translations.logout" inverted color="gray" :disabled="areButtonsDisabled"/>
      </div>
      <div>
        <bb-button @click="onProceed" data-testid="proceed-permission-confirmation-modal"
                   class="p-x-5 w-100" :label="translations.proceed" :disabled="areButtonsDisabled"/>
      </div>
    </div>
  </bb-modal>
</template>

<script>
import LogoutReason from '@/types/logout-reason'
import '@bigbank/interface-components/dist/svg/illustration/money'

export default {
  data () {
    return {
      areButtonsDisabled: false
    }
  },
  computed: {
    translations () {
      return {
        modalTitle: this.$pgettext('confirm_permissions_modal', 'User rights assigning'),
        toUseInternetBank: this.$pgettext('confirm_permissions_modal', 'To use the Internet Bank, you must first <span class="f-strong">assign user rights to yourself</span>.'),
        withoutCompleting: this.$pgettext('confirm_permissions_modal', 'Without completing this step, <span class="f-strong">you will not be able to access or use the Internet Bank</span>.'),
        whatToDo: this.$pgettext('confirm_permissions_modal', 'What you need to do:'),
        list: [
          this.$pgettext('confirm_permissions_modal', 'Proceed by pressing on button "Proceed"'),
          this.$pgettext('confirm_permissions_modal', 'Get acquainted with rights assigned to you'),
          this.$pgettext('confirm_permissions_modal', 'Confirm and sign')
        ],
        mandatoryStep: this.$pgettext('confirm_permissions_modal', 'This is a <span class="f-strong">mandatory</span> step to ensure secure access and proper functionality of your account.'),
        contactCustomerSupport: this.$pgettext('confirm_permissions_modal', 'If you need assistance, please contact our customer support team.'),
        thankYou: this.$pgettext('confirm_permissions_modal', 'Thank you for your attention and cooperation!'),
        logout: this.$pgettext('confirm_permissions_modal', 'Log out'),
        proceed: this.$pgettext('confirm_permissions_modal', 'Proceed')
      }
    },
    modalProps () {
      return {
        flavor: 'card',
        fullMobile: true,
        centerVertically: true,
        hideClose: true,
        staticOverlay: true,
        visible: true,
        publicSize: 'm'
      }
    }
  },
  methods: {
    onLogout () {
      this.areButtonsDisabled = true
      this.$router.push({ path: '/logout', query: { reason: LogoutReason.OPEN_CURRENT_ACCOUNT_MODAL } })
    },
    onProceed () {
      this.areButtonsDisabled = true
      this.onProceedFn()
    }
  },
  props: {
    onProceedFn: {
      type: Function,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  color: $blue;
  font-weight: 500;
  font-size: $font-size-small;
  font-family: $gotham-medium;
  line-height: 18px;
  text-align: center;
}

.icon-wrapper {
  display: flex;
  justify-content: center;
}

.icon {
  max-width: 205px;

  @media (max-width: $mobile-view-breaking-point) {
    max-width: 155px;
  }
}

.current-account-modal__list-item {
  display: flex;
}

.text {
  color: $gray;
  font-family: $gotham-book;
  line-height: 18px;
  font-size: $font-size-small;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  column-gap: 15px;
  padding: 0 10px 10px;
  align-items: stretch;

  @media (max-width: $mobile-view-breaking-point) {
    padding: 20px;
  }

  div {
    flex: 1 0 0;
    display: flex;
  }
}

.mint > li::before {
  background-color: $mint;
}

</style>
